// action - state management
import { LOGIN, LOGOUT, REGISTER } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    accessToken: null
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user, accessToken } = action.payload;
            return {
                ...state,
                user,
                accessToken
            };
        }
        case LOGIN: {
            const { user, accessToken } = action.payload;

            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user,
                accessToken
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                accessToken: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
